'use strict';

angular.module('DoohApps').factory('MediaDevicesData', ['restApi', 'DoohConfig', 'Constants', function (restApi, DoohConfig, Constants) {
    var controllerName = 'MediaScreen/';

    return {
        deleteMediaDevice: function (successCallback, id) {
            restApi.DeleteApiMethod(successCallback, controllerName + 'DeleteMediaDevice?Id=' + id);
        },
        ForceUpdate: function (successCallback, mediaId) {
            restApi.GetApiMethod(successCallback, controllerName + 'ForceUpdate?MediaDeviceId=' + mediaId);
        },
        getMediaDeviceLog: function (successCallback, filter) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetMediaDeviceLog', filter);
        },
        getDownloadLogUrl: function (filter) {
            return restApi.GetApiMethodDownloadUrl(controllerName + 'DownloadLog', filter);
        },
        loadSettings: function (successCallback, MediaDeviceId) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetMediaDeviceSettings?MediaDeviceId=' + MediaDeviceId);
        },
        getMediaScreenList: function (successCallback, filter) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetMediaScreenList', filter);
        },
        getScreenByMediaId: function (successCallback, mediaId) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetScreenByMediaId?MediaId=' + mediaId);
        },
        sendScreenShotUpdateRequest: function (successCallback, mediaId) {
            restApi.GetApiMethod(successCallback, controllerName + 'SendScreenShotUpdateRequest?MediaId=' + mediaId);
        },
        sendSystemInfoUpdateRequest: function (successCallback, mediaId) {
            restApi.GetApiMethod(successCallback, controllerName + 'SendSystemInfoUpdateRequest?MediaId=' + mediaId);
        },
        updateSettings: function (successCallback, settings) {
            restApi.PutApiMethod(successCallback, controllerName + 'UpdateMediaDeviceSettings', settings);
        },
        regenerateDeviceKey: function (successCallback, deviceID) {
            restApi.GetApiMethod(successCallback, controllerName + 'RegenerateDeviceKey?deviceID=' + deviceID);
        },
        updateTransitionLogo: function (successCallback, data) {
            restApi.PostApiMethod(successCallback, controllerName + 'UpdateDeviceTransitionLogo', data);
        },
        deleteTransitionLogo: function (successCallback, companyID, deviceID, groupID) {
            restApi.GetApiMethod(successCallback, controllerName + 'DeleteTransitionLogo?companyID=' + companyID + '&deviceID=' + deviceID + '&groupID=' + groupID);
        },
        GetDevices: function (successCallback, filter) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetDevices', filter);
        },
        GetDevicesInGroup: function (successCallback, filter) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetDevicesInGroup', filter);
        },
        GetDeviceGroups: function (successCallback, filter) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetDeviceGroups', filter);
        },
        createDeviceGroup: function (successCallback, data) {
            restApi.PostApiMethod(successCallback, controllerName + 'CreateDeviceGroup', data);
        },
        getGroupConfigDetails: function (sucessCallback, groupID) {
            restApi.GetApiMethod(sucessCallback, controllerName + 'GetGroupConfigDetails?groupID=' + groupID);
        },
        updateGroupDetails: function (successCallback, data) {
            restApi.PostApiMethod(successCallback, controllerName + 'UpdateGroupDetails', data);
        },
        getNotAddedDevicesForGroup: function (sucessCallback, groupID) {
            restApi.GetApiMethod(sucessCallback, controllerName + 'GetNotAddedDevicesForGroup?groupID=' + groupID);
        },
        AddRemoveDevicesToGroup: function (successCallback, data) {
            restApi.PostApiMethod(successCallback, controllerName + 'AddRemoveDevicesToGroup', data);
        },
        getMediaDeviceGroupSettings: function (sucessCallback, groupID) {
            restApi.GetApiMethod(sucessCallback, controllerName + 'GetMediaDeviceGroupSettings?groupID=' + groupID);
        },
        updateGroupSettings: function (successCallback, settings) {
            restApi.PutApiMethod(successCallback, controllerName + 'UpdateGroupDeviceSettings', settings);
        },
        deleteDeviceGroup: function (sucessCallback, groupID) {
            restApi.DeleteApiMethod(sucessCallback, controllerName + 'DeleteDeviceGroup?groupID=' + groupID);
        },
        getAppDeviceMissingLicenses: function (sucessCallback, groupID, mediaDevs) {
            restApi.GetApiMethod(sucessCallback, controllerName + 'GetAppDeviceMissingLicenses?groupID=' + groupID + '&mediaDevices=' + mediaDevs);
        },
        checkDeviceGroupSchedule: function (sucessCallback, groupID) {
            restApi.GetApiMethod(sucessCallback, controllerName + 'CheckDeviceGroupSchedule?groupID=' + groupID);
        },
        requestDeviceRestart: function (successCallback, mediaId) {
            restApi.GetApiMethod(successCallback, controllerName + 'RequestDeviceRestart?MediaId=' + mediaId);
        },
    }
}])